import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { ScreenActionComponent } from "./components/ScreenActionComponent";
import { KindComponent } from "./components/KindComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);

// Custom Components
window.customElements.define("screen-action", ScreenActionComponent);
window.customElements.define("kind-component", KindComponent);
